/* import __COLOCATED_TEMPLATE__ from './answer-filter.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();